import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ChevronDown } from "lucide-react";
import Logo from "../media/logo.jpg";
import { Link } from "react-router-dom";

export default function Header(){
  const [menuOpen, setMenuOpen] = useState(false);
  const [apparelOpen, setApparelOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleApparel = () => setApparelOpen(!apparelOpen);

  const leftLinks = [
    { name: "Home", to: "/" },
    { name: "Our Story", to: "/our-story" },
    { name: "Culture", to: "/culture" },
    { name: "Our Philosophy", to: "/our-philosophy" },
    { name: "Sustainability, Ethics & Compliance", to: "/sustainability-ethics-compliance" },
    { name: "Digitalisation", to: "/digitalisation" },
    { name: "Contact Us", to: "/contact-us" },
  ];

  const leftLinks_1 = [
    { name: "Home", to: "/" },
    { name: "Our Story", to: "/our-story" },
    { name: "Culture", to: "/culture" },
    { name: "Our Philosophy", to: "/our-philosophy" },
    { name: "Sustainability, Ethics & Compliance", to: "/sustainability-ethics-compliance" }
  ];

  const leftLinks_2 = [
    { name: "Digitalisation", to: "/digitalisation" },
    { name: "Contact Us", to: "/contact-us" },
  ];

  const apparelLinks = [
    { name: "Menswear", to: "/menswear" },
    { name: "Womenswear", to: "/womenswear" },
    { name: "Kidswear", to: "/kidswear" },
    { name: "Promotional Wear", to: "/promotional-wear" },
    { name: "Workwear", to: "/workwear" },
    { name: "Uniform", to: "/uniform" },
    { name: "Sportswear", to: "/sportswear" },
    { name: "Home Textile", to: "/home-textile" },
    { name: "Shoes", to: "/shoes" },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-md flex justify-between items-center px-6 py-2">
      {/* Logo */}
      <div className="text-3xl md:text-5xl font-bold text-black flex items-center">
        <a className="flex items-center" href="/">
          <img src={Logo} alt="yking-logo" className="h-12 md:h-20" />
          <span>YKING</span>
        </a>
      </div>

      {/* Menu Button */}
      <button onClick={toggleMenu} className="text-gray-800 z-50">
        {menuOpen ? "" : <Menu size={28} />}
      </button>

      {/* Fullscreen Overlay Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            key="menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0  bg-white pt-2 text-gray-700 flex flex-col items-center justify-start md:pt-0 z-40 overflow-y-auto"
          >
            {/* Close Button */}
            <button
              onClick={toggleMenu}
              className="absolute top-6 right-6 text-gray-700"
            >
              <X size={32} />
            </button>

            {/* --- For Mobile --- */}
            <div className="block md:hidden space-y-4">
              <div className="text-3xl pt-2 pl-2 font-bold flex text-black items-center">
                <a className="flex items-center" href="/">
                  <img src={Logo} alt="yking-logo" className="h-12" />
                  <span>YKING</span>
                </a>
              </div>

              {/* Menu Layout */}
              <div className="w-full px-6 h-screen text-center">
                {leftLinks_1.map((link, i) => (
                  <motion.div
                    key={link.name}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: i * 0.05 }}
                  >
                    <Link
                      to={link.to}
                      onClick={() => setMenuOpen(false)}
                      className="block text-lg font-semibold hover:text-brand transition-colors"
                    >
                      {link.name}
                    </Link>
                  </motion.div>
                ))}

                {/* Apparel Dropdown */}
                <div>
                  <button
                    onClick={toggleApparel}
                    className="flex items-center justify-center w-full text-lg font-semibold hover:text-brand transition-colors"
                  >
                    Apparel <ChevronDown className="ml-2" size={18} />
                  </button>

                  <AnimatePresence>
                    {apparelOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        className="overflow-hidden mt-2 space-y-2"
                      >
                        {apparelLinks.map((link) => (
                          <Link
                            key={link.name}
                            to={link.to}
                            onClick={() => setMenuOpen(false)}
                            className="block text-base leading-5 text-gray-700 hover:text-brand transition-colors"
                          >
                            {link.name}
                          </Link>
                        ))}
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>

                {leftLinks_2.map((link, i) => (
                  <motion.div
                    key={link.name}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: i * 0.05 }}
                  >
                    <Link
                      to={link.to}
                      onClick={() => setMenuOpen(false)}
                      className="block text-lg font-semibold hover:text-brand transition-colors"
                    >
                      {link.name}
                    </Link>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* --- For Desktop --- */}
            <div className="hidden md:flex md:items-center md:space-x-24 md:justify-center w-full">
              <div className="text-5xl h-screen pt-36 font-bold text-black flex items-start">
                <a className="flex items-center" href="/">
                  <img src={Logo} alt="yking-logo" className="h-20" />
                  <span>YKING</span>
                </a>
              </div>

              {/* Left Column */}
              <div className="space-y-4">
                {leftLinks.map((link, i) => (
                  <motion.div
                    key={link.name}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: i * 0.05 }}
                  >
                    <Link
                      to={link.to}
                      onClick={() => setMenuOpen(false)}
                      className="block text-lg font-semibold hover:text-brand transition-colors"
                    >
                      {link.name}
                    </Link>
                  </motion.div>
                ))}
              </div>

              {/* Right Column (Apparel Categories) */}
              <div className="space-y-4">
                {apparelLinks.map((link, i) => (
                  <motion.div
                    key={link.name}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: 0.2 + i * 0.05 }}
                  >
                    <Link
                      to={link.to}
                      onClick={() => setMenuOpen(false)}
                      className="block text-lg font-semibold hover:text-brand transition-colors"
                    >
                      {link.name}
                    </Link>
                  </motion.div>
                ))}
              </div>
            </div>

          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
